import { NavigationData, Report } from 'core/slices/models';
import { extractActiveReportName } from './extractActiveReportName';
import { flattenReports } from '../../domain/functions/flattenReports';
import { getReportById } from './getReportById';

export const getActiveReport = ({
  navData,
  pathname,
  defaultId,
}: {
  navData: NavigationData;
  pathname: string;
  defaultId: string;
}): Report | undefined => {
  const activeReportId = extractActiveReportName(pathname);
  const reports = flattenReports(navData);
  return getReportById(reports, activeReportId, defaultId);
};
